<form [formGroup]="materialForm" class="d-flex">
  <div class="right-space">
    <div class="form-sub-title">Materiaalkeuze</div>

    <mat-form-field class="" appearance="outline">
      <mat-select
        matInput
        placeholder="Maak een keuze"
        formControlName="material"
        required
        (selectionChange)="materialChange($event)"
      >
        <mat-option *ngFor="let option of materialOptions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="right-space">
    <div class="form-sub-title">Laminaat</div>

    <mat-form-field class="" appearance="outline">
      <mat-select
        matInput
        placeholder="Maak een keuze"
        formControlName="laminate"
        required
        (selectionChange)="laminateChange($event)"
      >
        <mat-option *ngFor="let option of laminateOptions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>
